import TableSearchState from "@/scenes/OrderManagement/redux/states/TableSearchState";
import { getOrderLatestProducts, GetOrderLatestProductsParams } from "@/services/api/order";
import { memoize } from "lodash";

/** 当以下搜索条件都不存在的时候,才会根据订单列表统计爆款商品 */
export function getCacheOrderUpdateFlag(search: TableSearchState) {
    let cacheOrderUpdateFlag = false;

    const {
        provinceCode,
        cityCode,
        districtCode,
        street,
        buyerUsername,
        consigneeName,
        printStatus,
        logisticsInfoStatus,
        logisticsCompany,
        itemQuantityFrom,
        itemQuantityTo,
        orderItemExternalId,
        originalIds,
        minPayment,
        maxPayment,
        phone,
        productOriginalId,
        skuOriginalId,
        stockNo,
        buyerRemarks,
        sellerRemarks,
        sellerFlags,
        shippingAreaId,
        shippingArea,
        timeFrom,
        timeTo,
        waybillNo,
        minWeight,
        maxWeight,
        markIds,
        quicks,
        retailerShopIds,
        undeliverableArea,
        supplierShopId,
        orderItemTitle,
        skuProperties,
        orderItemTitleValue = {},
        orderItemExternalIdValue = {},
        skuPropertiesValue = {},
    } = search || {};

    if (
        !provinceCode &&
        !cityCode &&
        !districtCode &&
        !street &&
        !buyerUsername &&
        !consigneeName &&
        !printStatus &&
        !logisticsInfoStatus &&
        !logisticsCompany &&
        !itemQuantityFrom &&
        !itemQuantityTo &&
        !orderItemExternalId &&
        !originalIds &&
        !minPayment &&
        !maxPayment &&
        !phone &&
        !orderItemTitle &&
        !productOriginalId &&
        !skuOriginalId &&
        !skuProperties &&
        !stockNo &&
        !quicks?.length &&
        !buyerRemarks &&
        !sellerRemarks &&
        !sellerFlags &&
        !shippingAreaId &&
        !shippingArea &&
        !timeFrom &&
        !timeTo &&
        !waybillNo &&
        !minWeight &&
        !maxWeight &&
        !markIds &&
        !retailerShopIds &&
        !undeliverableArea &&
        !supplierShopId &&
        !orderItemTitleValue?.titleFieldSkuKeys?.length &&
        !skuPropertiesValue?.skuPropertiesFieldSkuKeys?.length &&
        !orderItemExternalIdValue?.externalIdFieldSkuKeys?.length
    ) {
        cacheOrderUpdateFlag = true;
    }

    return cacheOrderUpdateFlag;
}

export const getOrderLatestProductsMemoize = memoize(
    getOrderLatestProducts,
    (params: GetOrderLatestProductsParams) =>
        String(params.hasPendingShipmentOrder) +
        String(params.loadProductSimpleTitle) +
        String(params.loadSkuSimpleTitle) +
        String(params.loadProductPicture) +
        params.shopIds?.join(),
);

const separation = "__separation__";

export function buildKey(shopId: number, id: string) {
    return shopId + separation + id;
}

export function getKeyInfo(key: string): [shopId?: number, id?: string] {
    if (!key) return [];

    const res = key.split(separation);

    if (res.length === 2) {
        const shopId = Number(res[0]);
        const id = res[1];

        return [shopId, id];
    }

    return [];
}
